// Google Maps initialization - Only load if #map container exists
// This prevents errors on pages that don't have a map

function initializeMapIfNeeded() {
  var mapEl = document.getElementById("map");
  if (!mapEl) {
    // Map container not found on this page - skip initialization
    return;
  }

  // Load Google Maps API only if container exists
  if (!window.google || !window.google.maps) {
    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyCey8Yfn5LLE3pG4lQT41bMdTvwCZVVepU&v=weekly&libraries=maps,marker&callback=initMap";
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  } else {
    initMap();
  }
}

// Global initMap callback for Google Maps API
window.initMap = function() {
  function createMap() {
    var mapEl = document.getElementById("map");
    if (!mapEl) return;

    const position = { lat: 44.933076, lng: 15.629058 };

    if (window.google && window.google.maps) {
      google.maps.importLibrary("maps").then(({ Map }) => {
        google.maps.importLibrary("marker").then(({ AdvancedMarkerElement }) => {
          const map = new Map(mapEl, {
            zoom: 6,
            center: position,
            mapId: "DEMO_MAP_ID",
          });

          new AdvancedMarkerElement({
            map: map,
            position: position,
            title: "Uluru",
          });
        });
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", createMap);
  } else {
    createMap();
  }
};

// Initialize map only if DOM is ready and container exists
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeMapIfNeeded);
} else {
  initializeMapIfNeeded();
}